import React from 'react';
import Lottie from 'react-lottie';

import { useItemsProviderContext } from '@common/react/components/Core/ItemsProvider/ItemsProvider';

import PetMemorialIcon from '@app/components/Pages/PetMemorial/PetMemorialIcon';
import { MemorialsRes } from '@app/objects/PetMemorial';

const arrowIcon = require('@app/images/arrow_circle.svg');
const lottieCandle = require('@app/content/animation/Lottie_Candle.json');
const lottieFloat = require('@app/content/animation/Lottie_Float.json');

interface PetMemorialHeadProps {
	onChangeSent: (e: boolean) => void;
	onChangeModalFormVisible: (e: boolean) => void;
}

const PetMemorialHead: React.FC<PetMemorialHeadProps> = ({ onChangeSent, onChangeModalFormVisible }) => {
	const context = useItemsProviderContext<MemorialsRes>();

	if (!context?.state) throw new Error('Error context');

	const {
		state: { items },
	} = context;

	const defaultOptions = {
		loop: false,
		autoplay: true,
		animationData: lottieCandle,
	};

	const defaultOptionsFloat = {
		loop: true,
		autoplay: true,
		animationData: lottieFloat,
	};

	return (
		<div className="pet-memorial-head">
			<div className="pet-memorial-head__wrapper">
				<Lottie options={defaultOptionsFloat} height={600} width={1400} />
				<div className="pet-memorial-head-content">
					<header className="pet-memorial-head__header">
						<h1>In Loving Memory</h1>
						<h6>Remembering the pets who have crossed the rainbow bridge and the paw prints they've forever left on our hearts.</h6>
						<button
							className="btn btn-primary"
							onClick={() => {
								onChangeSent(false);
								onChangeModalFormVisible(true);
							}}
						>
							Create a memorial for your pet
						</button>
					</header>
					{items
						.filter((item) => item.images?.length && item.images[0].split('.').length > 1)
						.slice(0, 8)
						.map((item, index) => (
							<PetMemorialIcon key={`pet-memorial-${index}`} index={index} item={item} />
						))}
				</div>
				<div className="pet-memorial-head__header-more">
					<span>Scroll for memorials</span>
					<img src={arrowIcon} alt="Arrow" />
				</div>
			</div>
			<Lottie options={defaultOptions} height={330} width={330} />
		</div>
	);
};

export default PetMemorialHead;
